import { useEffect } from "react";
import Dashboard from "./Dashboard";

// Renders the full dashboard shell (sidebar + chrome) and switches to the workspace tab.
const Workspace = () => {
  useEffect(() => {
    // Dispatch on mount and also slightly delayed to ensure Dashboard listener is attached.
    const dispatch = () =>
      window.dispatchEvent(new CustomEvent("orbit:navigate-tab", { detail: "workspace" }));
    dispatch();
    const t = setTimeout(dispatch, 50);
    return () => clearTimeout(t);
  }, []);

  return <Dashboard />;
};

export default Workspace;
